import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StickyCall from "../components/StickyCall";
import { Phone, MapPin, Clock, Send, MessageCircle } from "lucide-react";
import { site } from "../mock";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { toast } from "../hooks/use-toast";

export default function Contact() {
  const [form, setForm] = useState({ nom: "", tel: "", ville: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    if (!form.nom || !form.tel) {
      toast({ title: "Champs manquants", description: "Merci d'indiquer votre nom et votre numéro de téléphone." });
      return;
    }
    toast({ title: "Votre demande a été transmise", description: `Merci ${form.nom}. Maître Diamma vous rappelle très prochainement, en toute discrétion.` });
    setForm({ nom: "", tel: "", ville: "", message: "" });
  };

  return (
    <div>
      <Header />
      <StickyCall />
      <section className="hero-radial py-14 md:py-20">
        <div className="container-narrow text-center max-w-3xl mx-auto">
          <p className="text-[11px] uppercase tracking-[0.3em] text-gold-deep mb-3">Prendre rendez-vous</p>
          <h1 className="font-display text-4xl md:text-5xl gold-gradient-text">Parlez à Maître Diamma</h1>
          <div className="gold-divider my-5 max-w-[220px] mx-auto" />
          <p className="text-gold-soft/95 leading-relaxed">
            Un simple appel peut changer votre vie. La première prise de contact est gratuite, sans engagement et strictement confidentielle. Maître Diamma vous écoute, ressent votre situation et vous indique la voie à suivre.
          </p>
        </div>
      </section>

      <section className="py-14 bg-charcoal">
        <div className="container-narrow grid md:grid-cols-2 gap-10">
          <div className="space-y-4">
            <InfoRow icon={<Phone className="w-5 h-5 text-gold" />} title="Ligne directe 7j/7" value={site.phone} href={`tel:${site.phoneRaw}`} />
            <InfoRow icon={<MessageCircle className="w-5 h-5 text-gold" />} title="WhatsApp" value={"Écrivez un message maintenant"} href={site.whatsapp} target />
            <InfoRow icon={<MapPin className="w-5 h-5 text-gold" />} title="Cabinet à Orléans" value={site.address} />
            <InfoRow icon={<Clock className="w-5 h-5 text-gold" />} title="Horaires" value={site.hours} />

            <div className="card-onyx rounded-xl p-6 mt-2">
              <h3 className="font-display text-lg text-gold mb-2">Zones d'intervention</h3>
              <p className="text-sm text-gold-soft/95 leading-relaxed">
                Orléans et ses 22 communes de métropole (Olivet, Fleury-les-Aubrais, Saran, Saint-Jean-de-Braye, Saint-Jean-de-la-Ruelle, Ingré…), tout le Loiret (Montargis, Gien, Pithiviers, Beaugency, Meung-sur-Loire…) et les villes voisines : Blois, Tours, Chartres, Bourges, Paris. Consultation à distance également possible partout en France.
              </p>
            </div>
          </div>

          <form onSubmit={submit} className="card-onyx rounded-xl p-6 md:p-7 space-y-4">
            <h3 className="font-display text-xl text-gold">Demande de rappel gratuit</h3>
            <p className="text-sm text-gold-soft/85 -mt-2">Maître Diamma vous recontacte discrètement dans la journée.</p>
            <div className="grid sm:grid-cols-2 gap-4">
              <Field label="Nom & Prénom" val={form.nom} on={(v) => setForm({ ...form, nom: v })} />
              <Field label="Téléphone" val={form.tel} on={(v) => setForm({ ...form, tel: v })} />
            </div>
            <Field label="Ville" val={form.ville} on={(v) => setForm({ ...form, ville: v })} />
            <div>
              <Label className="text-gold-soft mb-2 block text-sm">Votre demande</Label>
              <Textarea
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                placeholder="Décrivez brièvement votre situation en toute confidentialité…"
                className="bg-black/40 border-[rgba(212,168,56,0.35)] text-gold-soft min-h-[140px] focus:border-[color:var(--gold-300)]"
              />
            </div>
            <button className="btn-gold rounded-md px-6 py-3 flex items-center gap-2 w-full justify-center">
              <Send className="w-4 h-4" /> Envoyer ma demande
            </button>
            <p className="text-xs text-gold-deep text-center">Discrétion totale garantie. Vos données ne sont jamais partagées.</p>
          </form>
        </div>
      </section>
      <Footer />
    </div>
  );
}

function InfoRow({ icon, title, value, href, target }) {
  const body = (
    <div className="card-onyx rounded-xl p-5 flex items-center gap-4">
      <div className="w-11 h-11 rounded-lg gold-border flex items-center justify-center shrink-0">{icon}</div>
      <div>
        <div className="text-[11px] uppercase tracking-widest text-gold-deep">{title}</div>
        <div className="text-gold-soft">{value}</div>
      </div>
    </div>
  );
  return href ? <a href={href} target={target ? "_blank" : undefined} rel="noreferrer" className="block">{body}</a> : body;
}

function Field({ label, val, on }) {
  return (
    <div>
      <Label className="text-gold-soft mb-2 block text-sm">{label}</Label>
      <Input value={val} onChange={(e) => on(e.target.value)} className="bg-black/40 border-[rgba(212,168,56,0.35)] text-gold-soft focus:border-[color:var(--gold-300)]" />
    </div>
  );
}
